/**
 * Settings for demo data generation
 */
export interface DemoDataSettings {
  /** Array of clinical site IDs */
  clinicalSiteIds: string[];
  /** Template for subject ID generation (e.g., "10-$&-$nnn") */
  subjectIdTemplate: string;
  /** Number of rows to generate */
  numberOfRows: number;
  /** Starting subject number for increment (default: 1) */
  startSubjectNumber: number;
}

/**
 * Default demo data settings
 */
export const DEFAULT_DEMO_DATA_SETTINGS: DemoDataSettings = {
  clinicalSiteIds: ['1'],
  subjectIdTemplate: '10-$&-$nnn',
  numberOfRows: 25,
  startSubjectNumber: 1,
};

